import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import useHttp from "../../../Hooks/use-http";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { littleRed } from "../../CommonComponent/DefineColors";

const CancelBooking = ({
  open,
  onClose,
  selectedRows,
  isRefresh,
  setSelectedRows,
}) => {
  const [cancelReason, setCancelReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { sendRequest } = useHttp();

  const handleConfirm = () => {
    // onConfirm(cancelReason);
    setIsLoading(true);
    sendRequest(
      {
        url: "/cancelShuttleBookings",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            cancelledOn: new Date(),
            cancelReason: cancelReason,
            cancelledBy: localStorage.getItem("user"),
            bookingIDs: selectedRows,
          },
        },
      },
      authenticateUser
    );
    setCancelReason("");
  };

  const authenticateUser = (data) => {
    try {
      setIsLoading(false);
      if (data.status === 200 || data.status === 201) {
        toast.success(data.message);
        // Clear selection
        setSelectedRows([]);
        // Toggle refresh
        isRefresh((prev) => !prev);
        // Close dialog - ensure this is called last
        onClose();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
      setSelectedRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Confirm Booking Cancellation</span>
          <IconButton
            onClick={onClose}
            sx={{
              color: littleRed,
              "&:hover": {
                backgroundColor: "rgba(213, 32, 41, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          The following Booking IDs are selected for cancellation:
        </DialogContentText>

        <div
          style={{
            margin: "16px 0",
            padding: "8px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
            maxHeight: "150px",
            overflowY: "auto",
          }}
        >
          {Array.isArray(selectedRows) &&
            selectedRows?.map((shiftId, index) => (
              <div key={index} style={{ margin: "4px 0" }}>
                {index + 1}. {shiftId}
              </div>
            ))}
        </div>

        <TextField
          autoFocus
          margin="dense"
          id="cancel-reason"
          label="Cancellation Reason"
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          placeholder="Please specify the reason for cancellation..."
          required
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={isLoading}
          sx={{
            backgroundColor: littleRed,
            color: "white",
            "&:hover": {
              backgroundColor: "#b01d25",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={!cancelReason.trim() || isLoading}
          startIcon={
            isLoading && <CircularProgress size={18} color="inherit" />
          }
        >
          {isLoading ? "Cancelling..." : "Confirm Cancellation"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelBooking;
